import { PageController } from '@client/components/_core/layout/PageController';
import { AttestationPersonRecordOverlay } from '@client/components/attestations/reporting/AttestationPersonRecordOverlay';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/attestations/overview/people/$userId')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Attestation record',
        },
        featureFlag: 'enable-attestation-reporting',
    },
    params: {
        parse({ userId }) {
            // A non-numeric segment is a 404, not a BigInt SyntaxError for Sentry.
            if (!/^\d+$/.test(userId)) throw notFound();
            return { userId: BigInt(userId) };
        },
        stringify({ userId }) {
            return { userId: String(userId) };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { userId } = Route.useParams();
    return (
        <PageController route={Route}>
            <AttestationPersonRecordOverlay userId={userId} />
        </PageController>
    );
}
